import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';

const MIN_QUERY_LENGTH = 2;

export const isMinQueryLengthExceeded = query => query.length > MIN_QUERY_LENGTH;

export const allowTransitionToSearchSection = allow => {
  SpatialNavigationWrapper.set('KEYBOARD', {
    leaveFor: {
      up: allow ? '@SEARCH_RESULTS' : '',
    },
  });
};
